import styled from "styled-components";
import { MenuIcon } from "../../atoms/icons/sidebar/MenuIcon";
import { SidebarCloseIcon } from "../../atoms/icons/sidebar/SidebarCloseIcon";
import { Logo } from "../../atoms/Logo";

type Props = {
  hideLogo?: boolean;
  isMenuOpen: boolean;
  onClick: () => void;
};

export const SidebarHeaderSP: React.FC<Props> = ({
  hideLogo,
  isMenuOpen,
  onClick,
}) => {
  return (
    <StyledHeaderContainer>
      <StyledHeaderContent>
        <StyledLogoContainer>
          {!hideLogo && <Logo width={120} height={25} />}
        </StyledLogoContainer>

        <StyledIconContainer onClick={onClick}>
          {isMenuOpen ? <SidebarCloseIcon /> : <MenuIcon />}
        </StyledIconContainer>
      </StyledHeaderContent>
    </StyledHeaderContainer>
  );
};

const StyledHeaderContainer = styled.div`
  display: flex;
  padding-left: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

const StyledHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

const StyledLogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
`;

const StyledIconContainer = styled.div`
  display: flex;
  padding: 20px;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;
